module.exports = __webpack_public_path__ + "static/media/sinha.6d94a23f.jpeg";